import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Banner = () => {
    const { t, i18n } = useTranslation()
    const [currentSlide, setCurrentSlide] = useState(0)
    const [isTransitioning, setIsTransitioning] = useState(false)
    const touchStartX = useRef(0)
    const touchEndX = useRef(0)
    const autoPlayRef = useRef(null)

    const lang = i18n.language === 'en' ? 'en' : 'tr'

    const slidesByLang = {
        tr: [
            'banner_v4.webp',
            'banner_v5.webp',
            'banner_v1.webp',
            'banner_v2.webp',
            'banner_v3.webp',
        ],
        en: [
            'banner_v4.webp',
            'banner_v5.webp',
            'banner_v1.webp',
            'banner_v2.webp',
            'banner_v3.webp',
        ],
    }

    const slides = slidesByLang[lang].map((filename) => ({
        image: `${process.env.PUBLIC_URL}/assets/images/banners/${lang}/${filename}`,
    }))

    const goToSlide = useCallback((index) => {
        if (isTransitioning) return
        setIsTransitioning(true)
        setCurrentSlide(index)
        setTimeout(() => setIsTransitioning(false), 600)
    }, [isTransitioning])

    const nextSlide = useCallback(() => {
        goToSlide((currentSlide + 1) % slides.length)
    }, [currentSlide, slides.length, goToSlide])

    const prevSlide = useCallback(() => {
        goToSlide((currentSlide - 1 + slides.length) % slides.length)
    }, [currentSlide, slides.length, goToSlide])

    // Auto-play
    useEffect(() => {
        autoPlayRef.current = setInterval(() => {
            nextSlide()
        }, 5000)
        return () => clearInterval(autoPlayRef.current)
    }, [nextSlide])

    // Touch/swipe support
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX
    }

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX
    }

    const handleTouchEnd = () => {
        const diff = touchStartX.current - touchEndX.current
        if (Math.abs(diff) > 50) {
            if (diff > 0) nextSlide()
            else prevSlide()
        }
    }

    // Mouse drag support
    const handleMouseDown = (e) => {
        touchStartX.current = e.clientX
    }

    const handleMouseUp = (e) => {
        const diff = touchStartX.current - e.clientX
        if (Math.abs(diff) > 50) {
            if (diff > 0) nextSlide()
            else prevSlide()
        }
    }

    return (
        <div
            className='banner-slider'
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
        >
            <div className='banner-slider-track'>
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                    >
                        <div className='banner-slide-overlay'></div>
                        <div className='container'>
                            <div className='banner-slide-content'>
                                <h1 className='banner-slide-title'>{slide.title}</h1>
                                <p className='banner-slide-subtitle'>{slide.subtitle}</p>
                                {slide.description && (
                                    <p className='banner-slide-description'>{slide.description}</p>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Navigation Arrows */}
            {/* <button className='banner-slider-arrow banner-slider-prev' onClick={prevSlide}>
                ‹
            </button>
            <button className='banner-slider-arrow banner-slider-next' onClick={nextSlide}>
                ›
            </button> */}

            {/* Dots */}
            <div className='banner-slider-dots'>
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`banner-slider-dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                    />
                ))}
            </div>
        </div>
    )
}

export default Banner